import { MemberContext } from 'src/app/models/member';
import { MemberService } from 'src/app/services/member/member.service';
import { Injectable } from '@angular/core';
import { Selector, SelectorOptions, State } from '@ngxs/store';

@State<any>({
    name: 'AGGREGATOR',
    defaults: undefined
})
@Injectable()
export class StateAggregator {

    @SelectorOptions({injectContainerState: false})
    @Selector([MemberService.memberContext])
    static aggregatorMember(memberContext: MemberContext) {
        return { memberContext };
    }



}
